import axios from "axios";
export default {
    deleteDocument: (documentId) => axios.post("/Documents/DeleteDocument", { Id: documentId })
};
